import { defineStore } from 'pinia';
import { getJourneys } from '@/core/collections/journeys/journeys.service';

export const useJourneysStore = defineStore('journeys', {
   state: () => ({
      journeyData: null as any,
   }),

   actions: {
      setJourneys(journeysResponse: any) {
         this.journeyData = journeysResponse.journeyData.value;
      },

      getJourneyOptions(locale: string) {
         return (
            this.journeyData?.data?.map((journey: any) => ({
               id: journey.id,
               name: journey.name[locale] || journey.id,
            })) || []
         );
      },

      getJourneyOptionsByTeam(locale: string, teamId: number | string | null | undefined) {
         if (!teamId) return [];
         return (
            this.journeyData?.data
               ?.filter((journey: any) => journey.teams?.some((team: any) => team.pivot.id === Number(teamId)))
               .map((journey: any) => ({
                  id: journey.id,
                  name: journey.name[locale] || journey.id,
               })) || []
         );
      },

      getTeamOptions() {
         const teams: { id: number; name: string }[] = [];
         this.journeyData?.data?.forEach((journey: any) => {
            journey.teams?.forEach((team: any) => {
               if (!teams.some((t) => t.id === team.pivot.id)) {
                  teams.push({ id: team.pivot.id, name: team.name });
               }
            });
         });
         return teams;
      },

      getTeamOptionsByJourney(journeyId: number | string | null | undefined) {
         if (!journeyId) return [];
         const journey = this.journeyData?.data?.find((j: any) => j.id === Number(journeyId));
         return journey?.teams?.map((team: any) => ({ id: team.pivot.id, name: team.name })) || [];
      },
   },
});
